<script lang="ts">
  import * as _ from "lodash";
  import ProductImage from "../ProductImage.svelte";
  import type { Storefront, StorefrontFeaturedProduct } from "@shared/types/Storefront";
  import type { ImageObj } from "@shared/types/Images";
  import UIRouterLink from "../UIRouterLink.svelte";
  import Icon from "../Icon.svelte";
  import { OnLayoutChange } from "@shared/svelte/Directives/OnLayoutChange.js";

  export let storefront: Storefront;
  export let orientation: string = "featured";
  export let maxHeight = null;

  let mobileMode: boolean = null;
  function updateMobileMode(name) {
    mobileMode = name == "mobile";
  }
  const enabledProp: string =
    orientation == "featured" ? "enable_featured_product" : "enable_featured_items";
  let imageObj: ImageObj;
  let chosenProduct: StorefrontFeaturedProduct;
  $: {
    chosenProduct = storefront.storefront_featured_products_attributes.find(function (x) {
      return x.orientation == orientation;
    });

    if (chosenProduct) {
      imageObj = {
        cloudinary_image_url: chosenProduct.use_provi_image
          ? _.get(chosenProduct, "product_line.cloudinary_image_url")
          : _.get(chosenProduct, "cloudinary_url"),
      };
    }
  }
  let aspectRatio = "55.9";
  if (orientation == "featured") {
    aspectRatio = "65.4";
  }
</script>

{#if chosenProduct && storefront[enabledProp]}
  <figure
    class={`${
      orientation == "featured"
        ? "fizz-card-featured-large fizz-stack-32"
        : "fizz-card-featured fizz-flex-item fizz-position-relative"
    }`}
    id="featured_product_{`${orientation}`}"
    data-grid-area={`${orientation}`}
    style={`position:relative; ${orientation != "featured" && !mobileMode ? "max-width: 50%" : ""}`}
    use:OnLayoutChange={updateMobileMode}
  >
    {#if chosenProduct.product_line.has_discount && orientation != "featured"}
      <div class="fizz-badge-icon-overlay fizz-text-positive">
        <Icon width="24" height="24" type="DealCircled" fill="#00875A" />
        <span>Deal</span>
      </div>
    {/if}
    <div class={orientation != "featured" ? "fizz-aspect-16-9" : ""}>
      <ProductImage
        product={imageObj}
        fizz={true}
        eTrimMode={chosenProduct.use_provi_image}
        {aspectRatio}
        {maxHeight}
      />
    </div>

    {#if orientation == "featured"}
      <figcaption>
        <div>
          {#if chosenProduct.product_line.has_discount}
            <div class="fizz-badge-icon fizz-text-positive fizz-stack-8">
              <Icon width="24" height="24" type="DealCircled" fill="#00875A" />
              <span>Deal</span>
            </div>
          {/if}
          <p class="fizz-text-medium fizz-text-subdued">
            {chosenProduct.product_line.brand_family_name || ""}
          </p>
          <h2 class="fizz-heading-2 fizz-stack-12">{chosenProduct.header || ""}</h2>
          <p class="fizz-stack-24" style="white-space: pre-line;">
            {chosenProduct.description || ""}
          </p>
          <UIRouterLink
            stateName="layout.product_detail"
            params={{ productId: chosenProduct.product_line.id }}
            classes="nounderline-hover"
          >
            <button class="fizz-button-primary">Shop Now</button>
          </UIRouterLink>
        </div>
      </figcaption>
    {:else}
      <figcaption class="fizz-text-center">
        <p class="fizz-text-medium fizz-text-subdued">
          {chosenProduct.product_line.brand_family_name || ""}
        </p>
        <h3 class="fizz-heading-3 fizz-stack-12">{chosenProduct.header || ""}</h3>

        <UIRouterLink
          stateName="layout.product_detail"
          params={{ productId: chosenProduct.product_line.id }}
          classes={"nounderline-hover"}
        >
          <button class="fizz-button-primary fizz-margin-auto">Shop Now</button>
        </UIRouterLink>
      </figcaption>
    {/if}
  </figure>
{:else if !chosenProduct && storefront[enabledProp]}
  {#if orientation == "featured"}
    <figure
      class="fizz-card-featured-large"
      id="featured_product_featured"
      data-grid-area="featured"
    >
      <div>
        <div class="fizz-placeholder" style="width: 100%; height: 0; padding-bottom: 55.9%;" />
      </div>
    </figure>
  {/if}
{/if}
